export enum ECommercePlatforms {
  SHOPIFY = "shopify",
  WIX = "wix",
}

export interface EcommerceIntegration {
  id: string
  platform: ECommercePlatforms
  name: string
  createdAt: string
  updatedAt: string
  data: { shop: string }
  status: EcommerceIntegrationStatus
}

export enum EcommerceIntegrationStatus {
  AUTH_REQUIRED = "auth_required",
  ACTIVE = "active",
  INACTIVE = "inactive",
}

export type EcommerceAuthenticatePayload = IShopifyAuthenticatePayload

export interface SharedAuthenticatePayload {
  name: string
}

export interface IShopifyAuthenticatePayload extends SharedAuthenticatePayload {
  request: {
    platform: ECommercePlatforms
    username: string
    callbackURL: string
  }
  name: string
}

export interface EcommerceValidatePayload {
  platform: ECommercePlatforms
  integrationId?: string
  data: { code: string; shop: string; hmac: string }
}

export interface EcommerceValidateResponse {
  createdAt: string
  id: string
  platform: ECommercePlatforms
  updatedAt: string
}

export interface EcommerceAuthenticateResponse {
  redirectURL: string
}

export interface PlatformConfig {
  platform: ECommercePlatforms
  icon: string
  active: boolean
}

export interface EcommerceShippingRule {
  name: string
  id: string
  dispatchRuleId: string
}
